export const conversationPaginationClasses = {
  root: "ConversationPagination-root",
  navItem: "ConversationPagination-navItem",
  navButton: "ConversationPagination-navButton",
  navButtonDir: (dir: "start" | "end") => `ConversationPagination-navButton-${dir}`,
} as const;
